import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const initialState = {
    contestAllList: [],
    isContestAllListLoaded: false,
    contestTypesList: [],
    isContestTypeLoaded: false,
    isDeleteLoaded: false,
    isOrderLoaded: false,
}

const contestSlice = createSlice({
    name: 'Contest',
    initialState,
    reducers: {
        setScrollId(state, action) {
            state.scrollId = action.payload.scrollId;
        }
    },
    extraReducers: (builder) => {

        builder.addCase(actions.getContestList.pending, (state) => {
            state.isContestAllListLoaded = false;
        })
        builder.addCase(actions.getContestList.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.contestAllList = action.payload.data;
            } else {
                state.contestAllList = [];
            }
            state.isContestAllListLoaded = true;
        })
        builder.addCase(actions.getContestList.rejected, (state) => {
            state.isContestAllListLoaded = false;
        });

        //delete 
        builder.addCase(actions.deleteContest.pending, (state) => {
            state.isDeleteLoaded = true;
        })
        builder.addCase(actions.deleteContest.fulfilled, (state, action) => {
            if (action.payload.success) {
                const id = action.payload.data;
                state.contestAllList = state.contestAllList.filter(item => item.baseId !== id);

            }
            state.isDeleteLoaded = false;
        })
        builder.addCase(actions.deleteContest.rejected, (state) => {
            state.isDeleteLoaded = false;
        });

        //Get Contest Types List

        builder.addCase(actions.getContestTypes.pending, (state) => {
            state.isContestTypeLoaded = false;
        })
        builder.addCase(actions.getContestTypes.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.contestTypesList = action.payload.data;
            } else {
                state.contestTypesList = [];
            }
            state.isContestTypeLoaded = true;
        })
        builder.addCase(actions.getContestTypes.rejected, (state) => {
            state.isContestTypeLoaded = false;
        });

        //Contest Order
        builder.addCase(actions.updateContestOrder.pending, (state) => {
            state.isOrderLoaded = true;
        })
        builder.addCase(actions.updateContestOrder.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.contestAllList = action.payload.data;
            } else {
                state.contestAllList = [];
            }
            state.isOrderLoaded = false;
        })
        builder.addCase(actions.updateContestOrder.rejected, (state) => {
            state.isOrderLoaded = false;
        });
    }
});

export const { setScrollId } = contestSlice.actions

export default contestSlice.reducer;